import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from '../../utils/axiosInstance';
import { toastSuccess, toastError } from '../../utils/alertHelper';

const IMAGE_BASE_URL = process.env.REACT_APP_Image_URL || '';

export default function ClientView() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/user') ? '/user' : '/admin';
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [preview, setPreview] = useState('');

  const img = (src) => (src ? (src.startsWith('http') ? src : `${IMAGE_BASE_URL}${src}`) : '');
  const bod = user?.birthDate ? String(user.birthDate).split('T')[0] : '';

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    axios.get(`/api/user/${id}`).then(res => {
      console.log('API Response:', res);
      let userData = null;
      if (res && res.data) {
        if (res.data.user) userData = res.data.user;
        else if (res.data.client) userData = res.data.client;
        else if (Array.isArray(res.data)) userData = res.data[0];
        else userData = res.data;
      }

      console.log('User data extracted:', userData);
      setUser(userData);
      if (userData) {
        toastSuccess('Client loaded');
      } else {
        toastError('User not found');
      }
      setLoading(false);
    }).catch(err => {
      console.error('Failed to fetch user', err);
      const msg = (err && err.response && err.response.data && err.response.data.Message) || err.message || 'Failed to load user';
      toastError(msg);
      setError('Failed to load user');
      setLoading(false);
    });
  }, [id]);

  const safeRender = (value, defaultValue = '-') => {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }

    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(', ') : defaultValue;
    }

    if (typeof value === 'object') {
      if (value.name) return value.name;
      if (value.title) return value.title;
      if (value._id) return value._id;
      if (value.id) return value.id;
      try {
        return JSON.stringify(value);
      } catch {
        return defaultValue;
      }
    }

    return String(value);
  };

  const getCategoryName = (c) => {
    if (c === null || c === undefined || c === '') return '';
    if (typeof c === 'object') return c.name || c._id || c.id || '';
    return String(c);
  };

  if (loading) return <div className="container-fluid py-4">Loading...</div>;
  if (error) return <div className="container-fluid py-4">{error}</div>;
  if (!user) return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">View Client Registration</h4>
        <button onClick={() => navigate(`${basePath}/client`)} className="btn btn-outline-secondary btn-sm">
          ← Client Registration
        </button>
      </div>
      <div>No user selected</div>
    </div>
  );

  const categoryName = getCategoryName(user.userCategory);

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 fw-bold">View Client Registration</h4>
        <button
          onClick={() => navigate(`${basePath}/client`)}
          className="btn btn-link text-decoration-none"
          style={{ fontSize: '14px', color: '#666' }}
        >
          ← Client
        </button>
      </div>

      <div className="row g-3">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-body p-4 rounded-3 border" style={{ background: "#F6F7F8" }}>
              <div className="d-flex justify-content-between align-items-center mb-3" style={{ paddingLeft: '55px' }}>
                <img
                  src={img(user.profilepic || user.profileImage || '/assets/image/innoveza.png')}
                  alt="profile"
                  className="rounded-circle"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    border: "1px solid #ddd"
                  }}
                />

                {/* Info */}
                <div className="flex-grow-1" style={{ paddingLeft: '30px' }} >
                  <h5 className="mb-1 fw-bold">
                    {safeRender(user.firstName)} {safeRender(user.lastName)}
                  </h5>

                  <div className="d-flex flex-wrap align-items-center gap-3 text-muted" style={{ fontSize: "16px" }}>
                    <span>
                      <i className="feather-phone me-2"></i>+91-
                      {safeRender(user.mobileNumber || user.phone)}
                    </span>
                    <span style={{ color: "#bbb" }}>|</span>
                    <span>
                      <i className="feather-phone me-2"></i>+91-
                      {safeRender(user.alternateNumber || user.mobileNumber || user.phone)}
                    </span>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-3 text-muted mt-1" style={{ fontSize: "16px" }}>
                    <span>
                      <i className="feather-mail me-2"></i>
                      {safeRender(user.email)}
                    </span>
                    <span style={{ color: "#bbb" }}>|</span>
                    <span>
                      <i className="feather-calendar me-2"></i>
                      {safeRender(bod)}
                    </span>
                  </div>

                  <div
                    className="mt-2 text-muted d-flex align-items-center gap-2"
                    style={{ fontSize: "16px" }}
                  >
                    <span>{safeRender(user.business || user.business)}</span>
                    <span style={{ color: "#bbb" }}>|</span>
                    <span>{safeRender(user.businessType || user.businesstype)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Account Information */}
        <div className="col-lg-6">
          <div className="card">
            <div className="card-body p-4 rounded-3 border" style={{ background: "#F6F7F8" }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 fw-bold" style={{ fontSize: "20px" }}>Account Information</h6>
                <button
                  onClick={() => navigate(`${basePath}/client/edit/${user._id || user.id}`)}
                  className="btn btn-primary btn-sm"
                  style={{ fontSize: '16px' }}
                >
                  <i className="bi bi-pencil me-2"></i>
                  Edit Client
                </button>
              </div>
              <div className="row g-3">
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    User Status
                  </div>
                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',paddingLeft:'19px',
                      color: user.userStatus === 'Active' ? '#28a745' : '#666'
                    }}
                  >
                    {safeRender(user.userStatus)}
                  </div>
                </div>
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    User Category
                  </div>
                  <div
                    style={{
                      fontSize: '16px', fontWeight: '600',paddingLeft:'25px',
                      color: categoryName === 'Gold' ? '#daaf16' : categoryName === 'Silver' ? '#000' : categoryName === 'Platinum' ? '#000' : '#201e1e'
                    }}
                  >
                    {safeRender(user.userCategory)}
                  </div>
                </div>
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    Account Status
                  </div>
                  <div
                    style={{
                      fontSize: '16px', fontWeight: '600', paddingLeft:'19px',
                      color: user.accountStatus === 'Pending'
                        ? '#F59E0B'
                        : user.accountStatus === 'Verified'
                          ? '#16A34A'
                          : user.accountStatus === 'Rejected'
                            ? '#DC2626'
                            : '#666'
                    }}
                  >
                    {safeRender(user.accountStatus)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Business Information */}
        <div className="col-lg-6">
          <div className="card">
            <div className="card-body p-4 rounded-3 border" style={{ background: "#F6F7F8" }}>
              <h6 className="mb-3 fw-bold"  style={{ fontSize: "20px" }}>Business Information</h6>
              <div className="row g-3">
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                    Gst Number
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.gstNumber || user.gst)}
                  </div>
                  {user.gst_certificate && (
                    <img
                      src={img(user.gst_certificate)}
                      alt="GST"
                      style={{
                        width: '100%',
                        height: 120,
                        objectFit: 'cover',
                        marginTop: 8,
                        borderRadius: 4,
                        cursor: 'pointer',
                        border: '1px solid #e0e0e0'
                      }}
                      onClick={() => setPreview(img(user.gst_certificate))}
                    />
                  )}
                </div>
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                    Adhaar Caard Number
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.aadharNumber)}
                  </div>
                  <div className="d-flex gap-2 mt-2">
                    {user.aadharFront && (
                      <img
                        src={img(user.aadharFront)}
                        alt="Aadhaar Front"
                        style={{
                          width: '100%',
                          height: 120,
                          objectFit: 'cover',
                          borderRadius: 4,
                          cursor: 'pointer',
                          border: '1px solid #e0e0e0'
                        }}
                        onClick={() => setPreview(img(user.aadharFront))}
                      />
                    )}
                  </div>
                  {user.aadharBack && (
                    <img
                      src={img(user.aadharBack)}
                      alt="Aadhaar Back"
                      style={{
                        width: '100%',
                        height: 120,
                        objectFit: 'cover',
                        marginTop: 8,
                        borderRadius: 4,
                        cursor: 'pointer',
                        border: '1px solid #e0e0e0'
                      }}
                      onClick={() => setPreview(img(user.aadharBack))}
                    />
                  )}
                </div>
                <div className="col-4">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '8px' }}>
                    Pan Card Number
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.pan_number || user.pan)}
                  </div>
                  {user.panimage && (
                    <img
                      src={img(user.panimage)}
                      alt="PAN"
                      style={{
                        width: '100%',
                        height: 120,
                        objectFit: 'cover',
                        marginTop: 8,
                        borderRadius: 4,
                        cursor: 'pointer',
                        border: '1px solid #e0e0e0'
                      }}
                      onClick={() => setPreview(img(user.panimage))}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bank Information */}
        <div className="col-lg-6">
          <div className="card">
            <div className="card-body p-4 rounded-3 border" style={{ background: "#F6F7F8" }}>
              <h6 className="mb-3 fw-bold"  style={{ fontSize: "20px" }}>Bank Information</h6>
              <div className="row g-3">
                <div className="col-6">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    Bank Name
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.bankName)}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    IFSC Code
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.ifsc_Code || user.ifsc)}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    Bank Number
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.accountNumber || user.bankNumber)}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ fontSize: '16px', color: '#666', marginBottom: '4px' }}>
                    Branch Name
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>
                    {safeRender(user.branchName || user.branch)}
                  </div>
                </div>
                <div className="col-12">
                  {(user.cancelCheque || user.cancelledCheque) && (
                    <img
                      src={img(user.cancelCheque || user.cancelledCheque)}
                      alt="Cancelled Cheque"
                      style={{
                        width: '100%',
                        maxHeight: 180,
                        objectFit: 'cover',
                        borderRadius: 4,
                        cursor: 'pointer',
                        border: '1px solid #e0e0e0'
                      }}
                      onClick={() => setPreview(img(user.cancelCheque || user.cancelledCheque))}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Address Information */}
        <div className="col-12">
          <div className="card">
            <div className="card-body p-4 rounded-3 border" style={{ background: "#F6F7F8" }}>
              <h6 className="mb-3 fw-bold" style={{ fontSize: "20px" }}>Address Information</h6>
              <div className="row">
                <div className="col-md-6">
                  <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                    Bill To:
                  </div>
                  <div style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                    {user.bill ? (
                      <>
                        {safeRender(user.bill.houseNo)}, {safeRender(user.bill.society)} {safeRender(user.bill.area)}<br />
                        {safeRender(user.bill.city)}, {safeRender(user.bill.state)} {safeRender(user.bill.pinCode)}
                      </>
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                    Ship To:
                  </div>
                  <div style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                    {Array.isArray(user.shipTo) && user.shipTo.length > 0 ? (
                      user.shipTo.map((s, idx) => (
                        <div key={s._id || idx} className="mb-2">
                          {safeRender(s.houseNo)}, {safeRender(s.societyName || s.society)} {safeRender(s.area)}
                          {safeRender(s.city)}, {safeRender(s.state)} {safeRender(s.pinCode)}
                        </div>
                      ))
                    ) : (
                      <div>-</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      {preview && (
        <div
          onClick={() => setPreview('')}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
            cursor: 'pointer'
          }}
        >
          <img
            src={preview}
            alt="preview"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: 8,
              boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
            }}
          />
        </div>
      )}
    </div>
  );
}